import type { DroneMapObject } from "../types";

export interface DroneRaw {
    id: string;
    x: number;
    y: number;
    yaw: number;
    isOnline: boolean;
    batteryPercentage: number;
    isCharging: boolean;
    model: string;
    [key: string]: unknown;
}

export function parseDrones(
    drones: DroneRaw[] | null | undefined,
): DroneMapObject[] {
    if (!Array.isArray(drones)) return [];

    return drones.map((drone) => ({
        id: drone.id,
        type: "drone",
        x: drone.x,
        y: drone.y,
        yaw: drone.yaw,
        isOnline: drone.isOnline,
        batteryPercentage: drone.batteryPercentage,
        isCharging: drone.isCharging,
        model: drone.model,
        interactive: true,
    }));
}
